import { sdkRequest } from '@eventbrite/http';
import { InteractionsLogger } from './interactionsLogger';
import { EventInteraction, EventInteractionContext } from './types';

export class InteractionsLoggerV1 implements InteractionsLogger {
    ORIGIN = 'web';
    log(interactions: EventInteraction<EventInteractionContext>[]) {
        const interactionsLogs = interactions.map((i) => {
            return {
                identity: {
                    user_id: i.user.id,
                    locale: i.user.locale,
                    tracking_code: null,
                    device_latitude: null,
                    device_longitude: null,
                },
                interface_context: {
                    app: this.ORIGIN,
                    interface: i.place.name,
                    placement_id: i.place.placementId,
                    rank: i.place.position,
                    absolute_rank: i.place.absoluteRank,
                    event_id: i.id,
                    ad_id: i.adId,
                    action: i.action,
                    tab_key: i.place.tabKey,
                    campaign_id: null,
                    page: i.place.page,
                    // log_engagement endpoint breaks if sub_interface / position are not sent
                    sub_interface: i.place.subInterface?.name || '',
                    position: i.place.subInterface?.position || '',
                },
                retrieval_context: i.place.context,
                display_context: {
                    has_open_promotion: Boolean(
                        i.displayContext?.hasOpenPromotion,
                    ),
                    urgency_signals: i.displayContext?.urgencySignals || [],
                },
                venue_context: {
                    venue_id: i.venueId || null,
                },
            };
        });
        sdkRequest('/api/v3/log_engagement/', {
            method: 'POST',
            body: JSON.stringify(interactionsLogs),
            headers: { 'EB-version': 'custom-events-next-version' },
        });
    }
}
